import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { IScoreType } from 'bets.oddprovider.lib.common.ts/models'
import { ApiResponseGetListData } from 'fwork-jsts-common/src/api'
import { IApiClientResult } from 'fwork-jsts-common/src/apiClient'
import { IDefaultAction, IDefaultState } from 'fwork.react.apptemplate'
import { FilterQuery } from 'mongoose'
import axios from '../../apiClient/axios'
import { ScoreTypesApiClient } from '../../apiClient/scoreTypes'

export interface IScoreTypesAction extends IDefaultAction {
  payload?: IScoreType[],
}

export interface IScoreTypesState extends IDefaultState {
  payload?: IScoreType[],
}

const initState: IScoreTypesState = {}

export const scoreTypesStateLoadFromApi = createAsyncThunk(
  'scoreTypesStateLoadFromApi',
  async (arg: {
    where?: FilterQuery<IScoreType>,
    onSuccess?: () => void,
    onError?: (msg?: string) => void,
    onFinally?: () => void
  }) => {
    const apiResult: IApiClientResult<ApiResponseGetListData<IScoreType>> = await new ScoreTypesApiClient(axios).get({
      where: arg.where,
      nested: 'sport',
      sort: { name: 1 }
    })

    if (apiResult.success) {
      if (arg.onSuccess)
        arg.onSuccess()
    }
    else if (arg.onError)
      arg.onError(apiResult.msg)

    if (arg.onFinally)
      arg.onFinally()
    return apiResult
  }
)

export const scoreTypesSlice = createSlice({
  name: 'scoreTypesSlice',
  initialState: initState,
  reducers: {
    clear: (state) => {
      state.payload = []
    }
  },
  extraReducers: (builder) => {
    builder.addCase(scoreTypesStateLoadFromApi.pending, (state) => {
      if (!state.options)
        state.options = {}
      state.options.loading = true
    })
    builder.addCase(scoreTypesStateLoadFromApi.fulfilled, (state, response) => {
      if (state.options)
        state.options.loading = false
      state.payload = response.payload.data?.payload
    })
    builder.addCase(scoreTypesStateLoadFromApi.rejected, (state) => {
      if (state.options)
        state.options.loading = false
    })
  }
})

export const { clear: clearScoreTypes } = scoreTypesSlice.actions
export default scoreTypesSlice.reducer